import { Modal, ModalTitle, ModalBody } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';

export type AgencyDesignationModalProps = {
  /**
   * Callback when the modal is closed
   */
  onClose: () => void;
};

/**
 * Modal displaying the agency designation terms for CoverMyMeds fax verification
 */
export const AgencyDesignationModal = ({ onClose }: AgencyDesignationModalProps) => {
  return (
    <Modal onClose={onClose} maxWidth="544px">
      <ModalTitle className="!p-8 !pb-0">Agency designation</ModalTitle>

      <ModalBody className="!gap-6 !p-8 !pt-6">
        <Typography styledAs="bodySmallDMSans" color="var(--grayscale-600)">
          Provider designates Agent with the authority to act on the Provider's behalf for purposes of creating an
          account with ("Third Party"): CoverMyMeds for User. Agent may, on Provider's behalf, accept the terms
          associated with the creation of an account through the Third Party and Agent may access and use the Third
          Party services on behalf of Provider as part of Agent's services to Provider. Provider understands and agrees
          to the terms associated with establishing Third Party account. Provider may direct Agent to terminate its
          Third Party account at any time but Provider understands that this may impact Agent's ability to provide
          Services.
        </Typography>
      </ModalBody>
    </Modal>
  );
};

export default AgencyDesignationModal;
